import {uniqueId} from 'lodash-es';
export const generateRandomId = (): string =>
  window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : uniqueId();
